module.exports = __webpack_public_path__ + "static/media/Grasmaaier.8db1ec08.mp3";